import { z } from 'zod';
import { getPasswordSchema } from '@/app/(auth)/forms/password-schema';

export const APPELLATIONS = [
  'CORBIERES',
  'MINERVOIS',
  'FITOU',
  'LANGUEDOC',
  'ROUSSILLON',
] as const;

export const APPELLATION_LABELS: Record<(typeof APPELLATIONS)[number], string> = {
  CORBIERES: 'Corbières AOP',
  MINERVOIS: 'Minervois AOP',
  FITOU: 'Fitou AOP',
  LANGUEDOC: 'Languedoc AOP',
  ROUSSILLON: 'Roussillon AOP',
};

export const getChateauSignupSchema = () => {
  return z
    .object({
      businessName: z
        .string()
        .min(2, { message: 'Business name must be at least 2 characters long.' }),
      siret: z
        .string()
        .regex(/^\d{14}$/, { message: 'SIRET must be exactly 14 digits.' }),
      appellation: z.enum(APPELLATIONS, {
        errorMap: () => ({ message: 'Please select an appellation.' }),
      }),
      region: z
        .string()
        .min(2, { message: 'Region is required.' }),
      description: z.string().max(2000).optional().or(z.literal('')),
      email: z
        .string()
        .email({ message: 'Please enter a valid email address.' }),
      password: getPasswordSchema(),
      passwordConfirmation: z.string().min(1, {
        message: 'Password confirmation is required.',
      }),
    })
    .refine((data) => data.password === data.passwordConfirmation, {
      message: 'Passwords do not match.',
      path: ['passwordConfirmation'],
    });
};

export type ChateauSignupSchemaType = z.infer<
  ReturnType<typeof getChateauSignupSchema>
>;
